import { render, staticRenderFns } from "./SetupProfileTab.vue?vue&type=template&id=fe172e40&scoped=true"
import script from "./SetupProfileTab.vue?vue&type=script&lang=js"
export * from "./SetupProfileTab.vue?vue&type=script&lang=js"
import style0 from "./SetupProfileTab.vue?vue&type=style&index=0&id=fe172e40&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe172e40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe172e40')) {
      api.createRecord('fe172e40', component.options)
    } else {
      api.reload('fe172e40', component.options)
    }
    module.hot.accept("./SetupProfileTab.vue?vue&type=template&id=fe172e40&scoped=true", function () {
      api.rerender('fe172e40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/setup-profile-tab/SetupProfileTab.vue"
export default component.exports